import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PublicOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"public_off"}/>
}
